import React from 'react';
import { useTheme } from  "../../theme/OAS365Theme";

export const SuccessToast = ({ title, description }) => {
  const theme = useTheme();
  return (
  <div style={{ fontFamily: theme.fonts.regular }}>
    <strong style={{ color: theme.colors.themeDarkColor }}>{title}</strong>
    <div style={{ fontSize: theme.fontSizes.menusize, color: theme.colors.themeFontColor }}>
      {description}
    </div>
  </div>
);
}

export const ErrorToast = ({ title, description }) => {
  const theme = useTheme();
  return (
  <div style={{
        fontFamily: theme.fonts.regular,
      }}>
    <strong style={{ color: theme.colors.validationColor }}>{title}</strong>
    <div style={{ fontSize: theme.fontSizes.menusize, color: theme.colors.themeFontColor }}>
      {description}
    </div>
  </div>
);
}

// Toast configuration presets
export const toastConfig = {
  success: {
    type: "success",
    autoClose: 4000,
    hideProgressBar: false,
    icon: false,
    className: "toast-custom-alldocument"
  },
  error: {
    type: "error",
    autoClose: 4000,
    hideProgressBar: false,
    icon: false,
    className: "toast-custom-alldocument",
    progressStyle: { backgroundColor: "#FF5C5C" }
  },
  default: {
    autoClose: 4000,
    hideProgressBar: false,
    icon: false,
    className: "toast-custom-alldocument"
  }
};

// Helper functions for common toast messages
export const ToastHelper = {
  checkinSuccess: (fileName) => ({
    title: "Successfully checked-in",
    description: `${fileName} was successfully checked-in`
  }),

  deleteSuccess: (fileName) => ({
    title: "Document Deleted",
    description: `${fileName} has been successfully deleted from OneDrive`
  }),

  deleteFailed: (errorMessage = "Failed to delete document. Please try again.") => ({
    title: "Delete Failed",
    description: errorMessage
  }),

  oneDriveDeleteFailed: () => ({
    title: "OneDrive deletion failed",
    description: "The file is currently locked by another user"
  })
};